/**
 * Some list endpoints in this codebase return a bare array (e.g. Division),
 * others the `{results}` pagination envelope (e.g. User) — and for the new
 * SEG Roles & Permissions endpoints (`access_role`, `permission`,
 * `user_role`) neither shape is confirmed yet against the real schema.
 * Reads whichever one actually comes back instead of guessing wrong and
 * silently rendering an empty table.
 */
export const unwrapList = <T,>(data: any): T[] => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};
